var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "#ADB5BD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30C27.8807 30 29 28.8807 29 27.5C29 26.1193 27.8807 25 26.5 25C25.1193 25 24 26.1193 24 27.5C24 28.8807 25.1193 30 26.5 30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27.5C44 28.8807 42.8807 30 41.5 30C40.1193 30 39 28.8807 39 27.5C39 26.1193 40.1193 25 41.5 25C42.8807 25 44 26.1193 44 27.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 35.8283C24.6527 35.1104 23.5461 35.0531 22.8283 35.7002C22.1104 36.3474 22.0531 37.4539 22.7002 38.1718C25.2593 41.0105 29.4287 42.75 34 42.75C38.5713 42.75 42.7407 41.0105 45.2998 38.1718C45.947 37.4539 45.8896 36.3474 45.1718 35.7002C44.4539 35.0531 43.3474 35.1104 42.7002 35.8283C40.9059 37.8187 37.7418 39.25 34 39.25C30.2582 39.25 27.0942 37.8187 25.2998 35.8283Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 63C41.2041 63 47.815 60.4607 52.9867 56.2284L65.1963 68.438C65.9773 69.219 67.2436 69.219 68.0247 68.438C68.8057 67.6569 68.8057 66.3906 68.0247 65.6095L55.909 53.4939C60.9276 48.131 64 40.9243 64 33C64 16.4315 50.5685 3 34 3C17.4315 3 4 16.4315 4 33C4 49.5685 17.4315 63 34 63ZM34 59C48.3594 59 60 47.3594 60 33C60 18.6406 48.3594 7 34 7C19.6406 7 8 18.6406 8 33C8 47.3594 19.6406 59 34 59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodFace);
export default __webpack_public_path__ + "static/media/good-face.fa1fae78.svg";
export { ForwardRef as ReactComponent };